import * as React from "react";

function ConectaZapSuccessIcon(props) {
  return (
    <svg
      width={41}
      height={41}
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x={0.25}
        y={0.318848}
        width={40}
        height={40}
        rx={20}
        fill="#689F38"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.34 12.401a2 2 0 012.82 2.835l-13.062 13a2 2 0 01-2.821 0l-5.938-5.909a2 2 0 112.822-2.835l4.527 4.505 11.651-11.596z"
        fill="#fff"
      />
    </svg>
  );
}

export default ConectaZapSuccessIcon;
